module.exports = __webpack_public_path__ + "media/images/web_suite/atlas_icon-9d8d7f7334a439949e7697b8517949f0.png";